<template>
  <div class="login">
    <div class="shodow">
      <!-- 登录 -->
      <div v-if="isShowUser == 1 && forgotPass == 0" class="login-item">
        <i class="el-icon-close" @click="closeLoginWin"></i>
        <div class="login-item-title">
          <span @click="toLogin()" class="login_to_login">Login</span>
          <span @click="toSignUp()" class="login_to_signup">Register</span>
        </div>
        <el-input
          @blur.native.capture="isInputNull(email)"
          v-model="email"
          validate-event
          placeholder="Email address"
        ></el-input>
        <el-input
          class="passwordInput"
          v-model="password"
          type="password"
          show-password
          placeholder="Password"
        ></el-input>
        <div class="rember-forgot">
          <!-- <input type="checkbox" name="remeberme" id="">Remember me -->
          <div @click="isForgotPassword()" class="forgot">
            Forgot my password
          </div>
        </div>
        <div
          :class="[
            'login-button',
            email != '' && password != '' ? 'orange-button' : 'gary-button',
          ]"
          @click="login"
        >
         Login
        </div>
        <div class="line">
          <div class="or">or</div>
        </div>
        <div class="face-google">
          <div @click="openFace" class="facebook">
            Facebook
          </div>
          <div @click="openGoogle" class="google">
            Google
          </div>
        </div>
        <!-- <div @click="isCloseLoginPage()" class="close">
          <i class="iconfont iconic_shop_shutdown"></i>
        </div> -->
      </div>
      <!-- 忘记密码 -->
      <div v-if="isShowUser == 1 && forgotPass == 1" class="login-item">
        <i class="el-icon-close" @click="closeLoginWin"></i>
        <div class="forgot-item-title">Please enter the email address you’d like your password reset information sent to.</div>
        <el-input
          @blur.native.capture="isInputNull(email)"
          v-model="email"
          validate-event
          placeholder="Email Address"
        ></el-input>
        <div
          @click="ResetPassword(email)"
          :class="[
            'forgot-button',
            email != '' ? 'orange-button' : 'gary-button',
          ]"
        >
          Reset your password
        </div>
        <div @click="isForgotPassword()" class="goBack">
          Go back to Login
        </div>
        <!-- <div @click="isCloseLoginPage()" class="close">
          <i class="iconfont iconic_shop_shutdown"></i>
        </div> -->
        <p class="emailTips" v-if="isEmail == 1">
          Email format error
        </p>
        <p class="emailTips" v-if="isAlreadyHave == 1">
          Email registered
        </p>
      </div>
      <!-- 注册 -->
      <div v-if="isShowUser == 2 && isRegisterSucces == 0" class="login-item">
        <i class="el-icon-close" @click="closeLoginWin"></i>
        <div class="login-item-title">
          <span @click="toLogin()" class="signup_to_login">Login</span>
          <span @click="toSignUp()" class="signup_to_signup">Register</span>
        </div>
        <el-input
          @blur.native.capture="isInputNull(email)"
          v-model="email"
          validate-event
          placeholder="Email Address"
        ></el-input>
        <el-input
          @blur.native.capture="isTruePassword(password)"
          v-model="password"
          type="password"
          show-password
          placeholder="Password"
        ></el-input>
        <el-input
          @blur.native.capture="isSamePassword(confirmPassword)"
          v-model="confirmPassword"
          type="password"
          show-password
          placeholder="Confirm Password"
        ></el-input>
        <div class="agreeServices">
          <span>By creating a account,you’re agreeing to accept,the</span>
          <span>onloon Items of services</span>
        </div>
        <div
          :class="[
            'login-button',
            email != '' && password != '' && confirmPassword != ''
              ? 'orange-button'
              : 'gary-button',
          ]"
          @click="register(email, password)"
        >
          Register
        </div>
        <!-- <div @click="isCloseLoginPage()" class="close">
          <i class="iconfont iconic_shop_shutdown"></i>
        </div> -->
        <p class="accountEmailTips" v-if="isEmail == 1">
          Email format error
        </p>
        <p class="accountEmailTips" v-if="isAlreadyHave == 1">
          Email registered
        </p>
        <p class="accountPasswordTips" v-if="isTruePass == 1">
          6-20 characters(letters plus numbers only)
        </p>
        <p class="accountPasswordSameTips" v-if="isSamePass == 1">
          The password is inconsistent
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import indexApi from '@/api/index/indexApi.js'
export default {
  name: 'login',
  props: {
    isShowUser: Number,
    baseApiUrl: String,
    shopId: String,
    fatherMethod: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      closeLogin: 0,
      forgotPass: 0,
      isEmail: 0, //验证邮箱
      isTruePass: 0, //验证密码
      isSamePass: 0, //验证重复密码
      isRegisterSucces: 0, //注册成功
      isAlreadyHave: 0, //用户已存在/不存在
    }
  },
  mounted() {
    // this.email = window.localStorage.getItem('emailKey') || ''
    window.info = this.info
  },
  methods: {
    toLogin() {
      this.isCloseLoginPage()
      this.$emit('update:isShowUser', 1)
    },
    toSignUp() {
      this.isCloseLoginPage()
      this.$emit('update:isShowUser', 2)
    },
    closeLoginWin () {
      this.$emit('update:isShowUser', -1)
      this.$emit('update:isLogin', false)
    },
    info() {
      var that = this
      indexApi.getAccountInfo()
        .then((req) => {
          if (!req.code) {
            if (req.data.data) {
              window.localStorage.setItem('emailKey', req.data.data.nickName)
              localStorage.setItem('GUEST_TAG', req.data.data.guestTag)
              localStorage.getItem('HAS_ORDER', req.data.data.orderTag ? 1 : 0)
              that.$message({
                message: 'Login success',
                type: 'success',
              })
              //登录了之后 关闭底部一键登录fb 和 gg
              window.sessionStorage.setItem('showChatKey', 1)
              location.reload()
            }
            that.isCloseLogin()
          } else {
            sessionStorage.clear()
            localStorage.clear()
          }
        })
    },
    ResetPassword(email) {
      if (this.isEmail == 2) {
        var that = this
        var params = {}
        params['loginAccount'] = email
        indexApi.getAccountCheck(params)
          .then((res) => {
            if (res.data.code == 1) {
              this.isAlreadyHave = 1
            } else {
              var params1 = {
                type: 2,
                email: email,
              }
              //   重置密码    --------->    newpsd  --->先发送邮箱
              indexApi.sendEmail(params1)
                .then(function (d2) {
                  if (!d2.data.code) {
                    that.$message({
                      message: 'Send Success',
                      type: 'success',
                    })
                  } else {
                    that.$message.error('Send Fail')
                  }
                })
            }
          })
      } else if (this.isEmail != 2) {
        this.isEmail = 1
      }
    },
    //邮箱验证
    isInputNull(text) {
      var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$')
      if (!reg.test(text)) {
        this.isEmail = 1
      } else {
        this.isEmail = 2
      }
      this.isAlreadyHave = 0
    },
    //密码格式验证
    isTruePassword(text) {
      // var pass = new
      // 、、var reg = /[A-Za-z0-9]{6,18}$/;
      // /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,16}$/;
      var pass = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,20}$/)
      if (!pass.test(text)) {
        this.isTruePass = 1
      } else {
        this.isTruePass = 2
      }
    },
    //密码是否一致验证
    isSamePassword(text) {
      if (text == this.password) {
        this.isSamePass = 2
      } else {
        this.isSamePass = 1
      }
    },
    isCloseLoginPage() {
      this.closeLogin = 0
      this.forgotPass = 0
      this.isRegisterSucces = 0
      this.$emit('fromClose', this.closeLogin, '')
      this.password = ''
      this.confirmPassword = ''
      this.isEmail = 0
      this.isTruePass = 0
      this.isSamePass = 0
      this.isAlreadyHave = 0
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = '' //出现滚动条
      document.removeEventListener('touchmove', mo, false)
    },
    isCloseLogin() {
      this.closeLogin = 0
      this.forgotPass = 0
      this.isRegisterSucces = 0
      this.$emit('fromClose', this.closeLogin, '')
      this.email = ''
      this.password = ''
      this.confirmPassword = ''
      this.isEmail = 0
      this.isTruePass = 0
      this.isSamePass = 0
      this.isAlreadyHave = 0
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = '' //出现滚动条
      document.removeEventListener('touchmove', mo, false)
      if (this.fatherMethod) {
        this.fatherMethod(this.email)
      }
    },
    isForgotPassword() {
      if (this.isRegisterSucces == 1) {
        this.forgotPass = 0
        this.isRegisterSucces = 0
        this.$emit('fromLogin', 1)
      } else {
        if (this.forgotPass == 0) {
          this.forgotPass = 1
        } else {
          this.forgotPass = 0
        }
      }
      this.email = ''
      this.password = ''
      this.confirmPassword = ''
      this.isEmail = 0
      this.isTruePass = 0
      this.isSamePass = 0
      this.isAlreadyHave = 0
    },
    //注册
    register(email, password) {
      if (this.isEmail == 2 && this.isTruePass == 2 && this.isSamePass == 2) {
        var params = {}
        params['loginAccount'] = email
        indexApi.getAccountCheck(params)
          .then((res) => {
            if (res.data.code == 0) {
              this.isAlreadyHave = 1
            } else {
              this.isRegisterSucces = 1
              this.$message({
                message: 'Sign success',
                type: 'success',
              })
              this.isCloseLoginPage()
              this.closeLoginWin()
              this.timer = setTimeout(() => {
                this.$emit('fromLogin', 1)
              }, 1000)
              var params1 = {
                password: password,
                regSource: 0,
                loginAccount: email,
              }
              //   注册    --------->    newpsd  --->先发送邮箱
              indexApi.sureRegister(params1)
            }
          })
      }
    },
    //登录
    login() {
      indexApi.getLoginKey()
        .then(({ data }) => {
          let key = window.RSAUtils.getKeyPair(
            data.data.exponent,
            '',
            data.data.modulus
          )
          let password = window.RSAUtils.encryptedString(key, this.password)
          let params = {
            loginAccount: this.email,
            password,
            rediskey: data.data.rediskey,
          }
          return params
        })
        .then((data) => {
          return indexApi.toLogin(data)
        })
        .then(({ data }) => {
          if (data.code) {
            this.$message.error(data.message)
          } else {
            window.localStorage.setItem('emailKey', this.email)
            window.localStorage.setItem('userId', data.data.userId)
            localStorage.setItem('USER_NAME', this.email)
            this.$message({
              message: 'Login success',
              type: 'success',
            })
            this.isCloseLogin()
            var mo = function (e) {
              e.preventDefault()
            }
            document.body.style.overflow = '' //出现滚动条
            document.removeEventListener('touchmove', mo, false)
            this.closeLoginWin()
            location.reload()
          }
        })
    },
    //打开facebook
    openFace() {
      var shopId = this.shopId
      var params = {
        callbackHtml:
          location.origin + location.pathname + '#' +
          '/facebookBack/?shopId=' +
          shopId + '&title=Facebook',
      }
      indexApi.fbLogin(params)
        .then((data) => {
          if (data.data.code === 0) {
            window.open(
              data.data.data,
              'newwindow',
              'height=400, width=600, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no'
            )
          }
        })
    },
    //打开谷歌openGoogle
    openGoogle() {
      var shopId = this.shopId
      var params = {
        callbackHtml:
          location.origin + location.pathname + '#' +
          '/facebookBack/?shopId=' +
          shopId + '&title=Google',
      }
      indexApi.ggLogin(params)
        .then((data) => {
          if (data.data.code === 0) {
            window.open(
              data.data.data,
              'newwindow',
              'height=400, width=600, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no'
            )
          }
        })
    },
  },
}
</script>

<style lang="less">
@media screen and (min-width: 768px) {
  .login {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
    .goBack {
      cursor: pointer;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 60px;
      color: #33475b;
    }
    .shodow {
      position: relative;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      .login-item {
        width: 420px;
        // height: 510px;
        background-color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 0 40px;
        border-radius: 6px;
        .emailTips {
          position: absolute;
          top: 105px;
          right: 40px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountEmailTips {
          position: absolute;
          top: 89px;
          right: 40px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountPasswordTips {
          position: absolute;
          top: 151px;
          right: 40px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountPasswordSameTips {
          position: absolute;
          top: 215px;
          right: 40px;
          font-size: 14px;
          color: #ff0000;
        }
        .login-item-title {
          text-align: center;
          font-size: 28px;
          font-weight: 500;
          color: #3b77f1;
          margin: 40px 0 30px;
          cursor: pointer;
          .login_to_login,
          .signup_to_login {
            margin-right: 40px;
          }
          .login_to_login,
          .signup_to_signup {
            color: #000;
          }
          .login_to_signup:hover,
          .signup_to_login:hover {
            color: #000;
          }
        }
        .forgot-item-title {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #33475b;
          margin: 60px 0 30px;
        }
        .agreeServices {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #33475b;
          margin: 0px 0 20px;
          span {
            display: block;
          }
        }
        .el-input__inner {
          width: 420px;
        }
        .el-input {
          width: 420px;
          margin-bottom: 24px;
        }
        .passwordInput {
          margin-bottom: 5px;
        }
        .rember-forgot {
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 29px;
          padding-left: 20px;
          input {
            position: absolute;
            line-height: 14px;
            width: 16px;
            height: 16px;
            left: 38px;
            top: 225px;
          }
          .forgot {
            color: #7c98b6;
            float: right;
            cursor: pointer;
          }
        }
        .login-button {
          width: 420px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 30px;
          position: relative;
        }
        .orange-button {
          background: #0066ff;
          border: 1px solid #0066ff;
          color: #ffffff;
        }
        .gary-button {
          background: #f4f4f5;
          border: 1px solid #d2d5d8;
          color: #a6acb1;
        }
        .forgot-button {
          width: 420px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 20px;
          position: relative;
        }
        .line {
          width: 420px;
          margin: 0 auto;
          height: 26px;
          border-top: 1px solid #dfe3eb;
          margin-bottom: 10px;
          .or {
            width: 50px;
            margin: 0 auto;
            height: 26px;
            background-color: #fff;
            margin-top: -13px;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            color: #33475b;
          }
        }

        .face-google {
          width: 42opx;
          .facebook {
            cursor: pointer;
            width: 45%;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            background-color: #3b5998;
            float: left;
            border-radius: 4px;
            margin-bottom: 30px;
          }
          .google {
            cursor: pointer;
            width: 45%;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            background-color: #dd4b39;
            float: right;
            border-radius: 4px;
            margin-bottom: 30px;
          }
        }
        .close {
          position: absolute;
          top: 16px;
          right: 20px;
          font-size: 24px;
          cursor: pointer;
          i {
            font-size: 24px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .login {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
    .shodow {
      position: relative;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      .login-item {
        width: calc(100vw - 70px);
        background-color: white;
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        padding: 0 20px;
        padding-bottom: 20px;
        border-radius: 6px;
        .emailTips {
          position: absolute;
          top: 105px;
          right: 20px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountEmailTips {
          position: absolute;
          top: 70px;
          right: 20px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountPasswordTips {
          position: absolute;
          top: 128px;
          right: 20px;
          font-size: 14px;
          color: #ff0000;
        }
        .accountPasswordSameTips {
          position: absolute;
          top: 188px;
          right: 20px;
          font-size: 14px;
          color: #ff0000;
        }
        .login-item-title {
          text-align: center;
          font-size: 28px;
          font-weight: 500;
          color: #3b77f1;
          margin: 40px 0 30px;
          cursor: pointer;
          .login_to_login,
          .signup_to_login {
            margin-right: 40px;
          }
          .login_to_login,
          .signup_to_signup {
            color: #000;
          }
          .login_to_signup:hover,
          .signup_to_login:hover {
            color: #000;
          }
        }
        .forgot-item-title {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #33475b;
          margin: 60px 0 24px;
        }
        .agreeServices {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #33475b;
          margin: 0px 0 20px;
        }
        .el-input__inner {
          width: calc(100vw - 70px);
        }
        .el-input {
          width: calc(100vw - 70px);
          margin-bottom: 20px;
        }
        .rember-forgot {
          font-size: 14px;
          line-height: 14px;
          margin-bottom: 40px;
          padding-left: 20px;
          input {
            position: absolute;
            line-height: 14px;
            width: 16px;
            height: 16px;
            left: 20px;
            top: 196px;
          }
          .forgot {
            color: #7c98b6;
            float: right;
            cursor: pointer;
          }
        }
        .login-button {
          width: calc(100vw - 70px);
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 28px;
          position: relative;
        }
        .orange-button {
          background: #0066ff;
          border: 1px solid #0066ff;
          color: #ffffff;
        }
        .gary-button {
          background: #f4f4f5;
          border: 1px solid #d2d5d8;
          color: #a6acb1;
        }
        .forgot-button {
          width: calc(100vw - 70px);
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 20px;
          position: relative;
        }
        .line {
          width: calc(100vw - 70px);
          margin: 0 auto;
          height: 22px;
          border-top: 1px solid #dfe3eb;
          margin-bottom: 11px;
          .or {
            width: 40px;
            margin: 0 auto;
            height: 22px;
            background-color: #fff;
            margin-top: -10px;
            text-align: center;
            line-height: 21px;
            font-size: 12px;
            color: #33475b;
          }
        }
        .goback {
          cursor: pointer;
          margin: 0 auto;
          text-align: center;
          color: #33475b;
          // margin-bottom: 40px;
        }
        .face-google {
          width: calc(100vw - 70px);
          .facebook {
            cursor: pointer;
            width: 45%;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            background-color: #3b5998;
            float: left;
            border-radius: 4px;
          }
          .google {
            cursor: pointer;
            width: 45%;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            background-color: #dd4b39;
            float: right;
            border-radius: 4px;
          }
        }
        .close {
          position: absolute;
          top: 14px;
          right: 26px;
          font-size: 20px;
          cursor: pointer;
          i {
            font-size: 24px;
          }
        }
      }
    }
  }
}
.login {
  .el-icon-close {
    position: absolute;
    top: 15px;
    font-size: 20px;
    right: 15px;
  }
}
</style>
